import React from 'react';
import * as Styled from './styled';

export interface Group {
  dimension: string;
  operator: string;
  values: (string | number)[];
}

export interface TagProps {
  data: {
    path: number[];
    groups: Group[];
  };
  onDelete?: () => void;
}

export const Tag = (props: TagProps) => {
  const { data, onDelete } = props;
  if (!data.groups.length) return null;

  return (
    <Styled.TagContainer>
      {
        data.groups.map((it, index) => {
          return (
            <>
              <Styled.TagText>{it.dimension}</Styled.TagText>
              <Styled.TagOperator>{it.operator}</Styled.TagOperator>
              <Styled.TagText>{
                it.values.map((v, vIndex) => {
                  return (
                    <span key={vIndex}>
                      {v}
                      {vIndex !== it.values.length - 1 && <Styled.Combinator>OR</Styled.Combinator>}
                    </span>
                  )
                })
              }</Styled.TagText>
              {index !== data.groups.length -1 && <Styled.Combinator>OR</Styled.Combinator>}
            </>
          );
        })
      }
      <Styled.DeleteIcon onClick={onDelete}/>
    </Styled.TagContainer>
  );
};